import React from 'react';

import './DrawerToggleButton.css';

const drawerToggleButton = props => (
  <button className="toggle_button" onClick={props.click} aria-label="Open navigation menu">
    <div className="toggle_button_line"></div>
    <div className="toggle_button_line"></div>
    <div className="toggle_button_line"></div>
  </button>
);


export default drawerToggleButton;
